export default __webpack_public_path__ + "static/media/nuevaesperanzahero.0c10beb8.jpg";